/**
 * Body del PATCH /users/:id que manda "Editar usuario".
 * roleId solo viaja si el admin CAMBIÓ el selector: el modal rellena un rol por defecto
 * cuando el usuario no tiene role_id (legacy), y guardar sin tocarlo no debe asignarle
 * un rol ni tirarle la sesión (cambiar el rol sube session_version).
 */
export function buildEditUserBody(form: {
  firstName: string;
  lastName: string;
  roleId: string;
  initialRoleId: string;
  homeBranchId: string;
}) {
  return {
    firstName: form.firstName,
    lastName: form.lastName,
    ...(form.roleId && form.roleId !== form.initialRoleId ? { roleId: form.roleId } : {}),
    // V76: null explícito = tenant-wide (quitar la sucursal base).
    homeBranchId: form.homeBranchId || null,
  };
}
